"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.discordCapperFinalizeSchema = exports.discordCapperSelectGuildSchema = exports.discordGuildNameSchema = exports.discordGuildIdSchema = void 0;
const zod_1 = __importDefault(require("zod"));
exports.discordGuildIdSchema = zod_1.default.string().max(500);
exports.discordGuildNameSchema = zod_1.default.string().max(100);
exports.discordCapperSelectGuildSchema = zod_1.default.object({ guild_id: exports.discordGuildIdSchema });
exports.discordCapperFinalizeSchema = zod_1.default.object({ guild_name: exports.discordGuildNameSchema, guild_id: exports.discordGuildIdSchema });
